import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Mensajes de correo',
  labels: {
    view_full_message: 'Ver mensaje completo',
    status: 'Estado:',
    on: 'Activo',
    off: 'Inactivo',
    next_send: 'Próximo envío: {{date}}.',
  },
  descriptions: {
    welcome:
      'Se envía una vez cuando un cliente se suscribe a tus correos de marketing, salvo los registros a través del formulario de tu tienda online. Un cliente recibe solo uno de estos: Bienvenida, Bienvenida al club de socios o Oferta de lanzamiento.',
    welcome_members_club:
      'Se envía una vez cuando alguien se registra a través del formulario de tu tienda online y no hay un código promocional de registro configurado, o se une a tu lista de miembros VIP. Un cliente recibe solo uno de estos: Bienvenida, Bienvenida al club de socios o Oferta de lanzamiento.',
    storefront_promo:
      'Se envía una vez cuando alguien se registra a través del formulario de tu tienda online mientras hay un código promocional de registro configurado. El correo incluye su código promocional personal.',
    launch_deal:
      'Se envía una vez a tus clientes importados, 30 minutos después de que tu restaurante se publique. Se omite a los clientes que ya recibieron Bienvenida o Bienvenida al club de socios.',
    we_miss_you:
      'Se envía a los suscriptores cuyo último pedido fue hace más de 45 días. Se comprueba cada mañana; un cliente lo recibe como máximo una vez cada 45 días.',
    happy_friday:
      'Se envía a todos los suscriptores a las 08:00 UTC el primer viernes de cada mes par (febrero, abril, junio, agosto, octubre, diciembre).',
    lazy_sunday:
      'Se envía a todos los suscriptores a las 08:00 UTC el primer domingo de cada mes impar (enero, marzo, mayo, julio, septiembre, noviembre).',
    loyalty_program:
      'Se envía cuando el saldo de cashback de un cliente alcanza el mínimo que puede gastar. Un cliente lo recibe como máximo una vez cada 30 días.',
    you_might_also_like:
      'Se envía 3 días después de un pedido con al menos 2 unidades del mismo artículo con un precio de 6,00 o más, recomendando uno de tus artículos más populares. Un cliente lo recibe como máximo una vez cada 30 días.',
  },
  tiles: {
    sends_count: 'Mensajes enviados',
    delivery_rate: 'Tasa de entrega',
    delivered_suffix: 'entregados',
    open_rate: 'Tasa de apertura',
    opened_suffix: 'abiertos',
    click_rate: 'Tasa de clics',
    clicked_suffix: 'clicados',
    spam_report_rate: 'Tasa de spam',
    spam_reports_suffix: 'reportes',
    unsubscribe_rate: 'Tasa de bajas',
    unsubscribes_suffix: 'bajas',
  },
  toasts: {
    failed_to_update_status: 'Error al actualizar el estado',
    failed_to_load_data: 'Error al cargar datos',
  },

  preview_modal: {
    title: 'Vista previa de plantilla',
    labels: {
      subject: 'Asunto:',
      close: 'Cerrar',
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos de vista previa',
    },
    template_data: {
      recipient_name: '&lt;Nombre&gt;',
    },
  },
};
